import React, { useEffect, useRef, useState } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { FormGroup } from "reactstrap";
import { useParams } from "react-router-dom";
import { getFromLocalStorage } from "../../../utils/webStorage";
import userService from "../../../services/user.service";
import { Form, Formik } from "formik";
import validationSchema from "../../../Validation/ValidationSchemas";
import { playLevelsOptions } from "../../../utils/constant";
import {
  openConfirmationPopup,
  openFailDialog,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";
import { useDispatch } from "react-redux";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import ContentLayoutHeader from "../../../Common/ContentLayoutHeader";
import Container from "@material-ui/core/Container";
import ImageUploadContainer from "../../../Common/FormFields/ImageUploadContainer";

const AddOrEditSports = () => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [sportsName, setSportsName] = useState("");
  const [editSportsName, setEditSportsName] = useState("");
  const { sportsId } = useParams();
  const [isAddSports, setIsAddSports] = useState(false);
  const [uploadId, setUploadId] = useState("");
  const [editUploadId, setEditUploadId] = useState("");
  const [playLevel, setPlayLevel] = useState("");
  const schoolId = getFromLocalStorage("schoolId");
  const [loading, setLoading] = useState({
    pageLoading: false,
    buttonLoading: false,
    profileImageLoading: false,
  });
  const dispatch = useDispatch();
  const formRef = useRef();
  useEffect(() => {
    if (sportsId) {
      setIsAddSports(false);
      setLoading((prevState) => ({
        ...prevState,
        pageLoading: true,
      }));
      getSportById();
      getSchoolDetails();
    } else {
      setIsAddSports(true);
    }
  }, []);

  const getSchoolDetails = () => {
    userService.getSchoolDetails(schoolId).then((res) => {
      const { data } = res.data;
      setPlayLevel(data.playLevel);
    });
  };

  const getSportById = () => {
    userService.getSportById(sportsId, schoolId).then((res) => {
      const data = res.data.data;
      if (data.uploadedLogo !== null) {
        setEditUploadId(data.uploadedLogo.id);
        setImagePreviewUrl(data.uploadedLogo.filePath);
      }
      setEditSportsName(data.sportName);
      setLoading((prevState) => ({
        ...prevState,
        pageLoading: false,
      }));
    });
  };

  const handleSubmit = ({ sport, playLevel }) => {
    setLoading((prevState) => ({
      ...prevState,
      buttonLoading: true,
    }));
    if (isAddSports) {
      userService
        .addSport(uploadId, playLevel, sport)
        .then((res) => {
          if (res.status == 200 && res.data.success == true) {
            openSuccessPopup(dispatch, {
              successPopUp: {
                message: "Sport Added Successfully",
                open: true,
                navigationLink: `/sports`,
              },
            });
          } else {
            openFailDialog(dispatch, {
              open: true,
              message: "Something Went Wrong",
            });
          }
          setLoading((prevState) => ({
            ...prevState,
            buttonLoading: false,
          }));
        })
        .catch((err) => {
          openFailDialog(dispatch, {
            open: true,
            message: "Something Went Wrong",
          });
          setLoading((prevState) => ({
            ...prevState,
            buttonLoading: false,
          }));
        });
    } else {
      userService
        .updateSport(sportsId, editUploadId, playLevel, sport, schoolId)
        .then((res) => {
          if (res.status == 200 && res.data.success == true) {
            openSuccessPopup(dispatch, {
              successPopUp: {
                message: "Sport Updated Successfully",
                open: true,
                navigationLink: `/sports`,
              },
            });
          }
          setLoading((prevState) => ({
            ...prevState,
            buttonLoading: false,
          }));
        })
        .catch((err) => {
          openFailDialog(dispatch, {
            open: true,
            message: "Something Went Wrong",
          });
          setLoading((prevState) => ({
            ...prevState,
            buttonLoading: false,
          }));
        });
    }
  };

  const handleLogoUpload = (file) => {
    setLoading((prevState) => ({
      ...prevState,
      profileImageLoading: true,
    }));
    const currentUserId = getFromLocalStorage("currentUserId");
    const data = new FormData();
    data.append("file", file);
    data.append("userId", currentUserId);

    userService
      .postLogoForAll(data)
      .then((res) => {
        const uploadId = res.data.data.id;
        const imageUrl = res.data.data.filePath;
        setImagePreviewUrl(imageUrl);
        if (isAddSports) {
          setUploadId(uploadId);
        } else {
          setEditUploadId(uploadId);
        }
        setLoading((prevState) => ({
          ...prevState,
          profileImageLoading: false,
        }));
      })
      .catch(() => {
        setLoading((prevState) => ({
          ...prevState,
          profileImageLoading: false,
        }));
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  const handleCancel = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Cancel?",
        btnColor: "red",
        btnText: "Yes",
        type: `${sportsId ? "Edit Sport" : "Add Sport"}`,
      },
    });
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        sport: sportsId ? editSportsName : sportsName,
        playLevel: playLevel,
      }}
      validationSchema={validationSchema.addOrEditSportSchema}
      enableReinitialize
      onSubmit={(values) => handleSubmit(values)}
    >
      {(formik) => (
        <Form>
          <div className="content-layout add-sectionn p-0 position-relative">
            <SchoolAdminDashboard />
            <ContentLayoutSpinner animate={loading?.pageLoading} />
            <ContentLayoutHeader
              heading={sportsId ? "Edit Sport" : "Add Sport"}
              handleCancel={handleCancel}
              navigationLink={"/sports"}
              btnText="Update"
              loading={loading?.buttonLoading}
              disabled={!formik.isValid}
            />
            <Container className="mg-top-70">
              <div name="adminRegistrationForm" className="moboMargin-5">
                <div className="col-12 col-lg-5">
                  <div className="white-card">
                    <ImageUploadContainer
                      id="upload-photo-1"
                      logoUrl={imagePreviewUrl}
                      handleUpload={handleLogoUpload}
                      label={imagePreviewUrl ? "Update Logo" : "Update Logo"}
                      loading={loading?.profileImageLoading}
                    />
                  </div>
                  <div className="clear20"></div>
                  <div className="white-card">
                    <div className="row fs-18 ">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <FormGroup className="fs-14">
                              <label className="fmlabel mt-6 semi-bold fs-18">
                                Play Level <span className="redstar">*</span>
                              </label>
                              <CustomDropDown
                                selected={playLevel}
                                setSelected={(value) => setPlayLevel(value)}
                                formik={formik}
                                fieldName="playLevel"
                                defaultSelectOption="Select Play Level"
                                options={playLevelsOptions}
                                fieldToShow="name"
                                optionValue="name"
                                isDisabled="disabled"
                              />
                            </FormGroup>
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <FormikTextField
                              label="Sport"
                              formik={formik}
                              fieldName="sport"
                              placeholder="Select Sport"
                              labelFontSize="fs-18"
                              isDisabled={true}
                            />
                          </div>
                        </div>
                        <div className="clear10"></div>
                      </div>
                    </div>
                  </div>
                  <div className="clear20"></div>
                  <div className="clear20"></div>
                </div>
              </div>
            </Container>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddOrEditSports;
